import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Td,
  Th,
} from "@graffer-inc/console-design-kit";
import { Loader } from "../../../../../organisms/common/loading";
import { SmartApplyR } from "../../../route";
import { useHistory } from "react-router-dom";
import { convertToFormattedId } from "@graffer-inc/cloud-gov-core";
import { TabUiState } from "../../../../../../application/service/smart-apply/application-detail/tab-ui-state";
import { formatDateString } from "../../../../../../utils/date-utils";
import { UnhandledQualifiedInvoiceIssueRequestResponse } from "@graffer-inc/smart-apply";

type Props = {
  isLoading: boolean;
  issueRequests: UnhandledQualifiedInvoiceIssueRequestResponse[];
};

export const UnhandledQualifiedInvoiceIssueRequestsTable = ({
  isLoading,
  issueRequests,
}: Props) => {
  const history = useHistory();

  return (
    <Table wrapper={false} borderType="row">
      <TableHeader>
        <TableRow>
          <Th>申請番号</Th>
          <Th>手続き名称</Th>
          <Th>初回依頼日時</Th>
        </TableRow>
      </TableHeader>
      <TableBody>
        <Loader isLoading={isLoading}>
          {issueRequests.map((r) => (
            <TableRow
              key={r.id}
              onClick={() => {
                history.push(
                  SmartApplyR.ApplicationDetail.link({
                    id: r.applicationId,
                    tab: TabUiState.payment(),
                  }),
                );
              }}
            >
              <Td>{convertToFormattedId(r.applicationId)}</Td>
              <Td>{r.applicationName}</Td>
              <Td>{formatDateString(r.createdAt)}</Td>
            </TableRow>
          ))}
        </Loader>
      </TableBody>
    </Table>
  );
};
